@if (extendSupport) {
  <div id="extend-support">
    <div class="help-categories">
      <h5>{{ 'Help Categories' | translate }}</h5>
      <ul>
        @for (category of helpCategories$ | async; track category) {
          <li>
            @if (category.tags | async; as tags) {
              @if (category.title | async; as title) {
                <a
                  href="#"
                  (click)="
                    updateSuggestions(tags); closeHelpCategoriesMenu(); $event.preventDefault()
                  ">
                  {{ title }}
                </a>
              }
            }
          </li>
        }
      </ul>
    </div>
    <a
      href="#"
      class="liveChat"
      (click)="openChat(); $event.preventDefault()">
      {{ 'Support' | translate }}
    </a>
  </div>
}
@if ((showsHelp$ | async) && !extendSupport && showWidgetAnimation) {
  <div id="extend-support-text">
    <p class="extend-support-content">
      {{ 'Access help articles and chat support here' | translate }}
    </p>
  </div>
}
